import { ReferenceItemFragment, useReference_RequestUpdToKvkMutation } from "@graphql";
import { useSnackbarsPipeline } from "@bonliva-crm/ui";
import { TICKET_SLIDER, TicketCreateLocation } from "@navigation";
import { CreateTicketData, ConsultantData } from "@tickets/TicketCreate/CreateTicketData";
import { store } from "@store";
import locale from "@bonliva-crm/locale";

export type RefCheckData = ReferenceItemFragment;

export type ReferenceRequestSentParams = {
  consultantData: ConsultantData;
  refGroupName: string;
};

export function getReferenceData(refData: RefCheckData) {
  return {
    _id: refData._id,
    name: refData.name,
    email: refData.email,
    formType: locale.consultantReferenceType[refData.formType],
    phone: refData.phone,
    position: refData.position,
    relation: refData.workPlace
  };
}

export function useReferenceUpdateRequestSent({
  consultantData,
  refGroupName
}: ReferenceRequestSentParams) {
  const snackbar = useSnackbarsPipeline();
  const [sendToKvk, { loading }] = useReference_RequestUpdToKvkMutation();

  const setRequestSent = (reference: RefCheckData) => {
    return new Promise((resolve, reject) => {
      const referenceData = getReferenceData(reference);

      console.log("rd", reference, referenceData);
      const ticketCreateData = CreateTicketData.ByReferenceType(
        consultantData,
        referenceData,
        true
      );

      store().navigation.open(
        TICKET_SLIDER,
        new TicketCreateLocation({
          itemName: refGroupName,
          initialValues: ticketCreateData,
          withReference: false,
          withCriminalRecord: false,
          consultantId: consultantData._id,
          descriptionRequired: false,
          dueDateRequired: true,
          onCreated: async (_, input) => {
            const _input = {
              AssignedTo: { PersonId: input.assignedUser?._id || store().user.id },
              Description: input.description,
              Due: input.dueDate || null,
              SecondaryText: input.dueDateText,
              AssignedTeam: input.assignedTeam,
              Tags: input.tags,
              LinkedItems: input.linkedItems,
              Priority: input.priority
            };

            return sendToKvk({
              variables: { refId: reference._id, input: _input }
            })
              .then((res) => {
                snackbar.showSuccess(locale.Ordered);
                resolve(res.data?.requestUpdToKvkConsultantReference);
                return res.data?.requestUpdToKvkConsultantReference;
              })
              .catch((e) => {
                reject(e);
                return null;
              });
          },
          onCancel: () => resolve(null),
          disabledList: ["assignedTeam"],
          dueDateProps: {
            disabled: ticketCreateData.dueDateDisabled,
            DatePickerProps: {
              helperText: ticketCreateData.dueDateText || ""
            }
          }
        })
      );

      store().navigation.on("close", TICKET_SLIDER, () => {
        resolve(null);
      });
    });
  };

  const onUpdRequestSent = (reference: RefCheckData) => {
    setRequestSent(reference)
      .catch((e) => {
        if (e === "ticket_cancel") {
          return;
        }

        console.error(e);
        snackbar.showError(e);
      })
      .finally(() => {
        console.log("finally");
      });
  };

  return { onUpdRequestSent, loading };
}
